<div class="filters-card k-card k-card-type-rich">
  <div class="k-card-body filters-section">
    <div class="form-group-inline">
      <div class="sync-now-container">
        <div class="radio-group">
          <label class="section-label"><strong>Category Type </strong></label>
          <label class="radio-option">
            <input
              type="radio"
              name="itemFilter"
              [checked]="isUnassign"
              (change)="onUnassignedToggle(true)"
            />
            <span><strong>Unassigned</strong></span>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="itemFilter"
              [checked]="!isUnassign"
              (change)="onUnassignedToggle(false)"
            />
            <span><strong>Assigned</strong></span>
          </label>
          <kendo-combobox
            class="type-dropdown"
            [data]="categories"
            textField="name"
            valueField="id"
            title=""
            placeholder="Category(ALL)"
            [filterable]="true"
            [valuePrimitive]="false"
            [(ngModel)]="selectedCategory"
            (filterChange)="handleFilter($event)"
            [hidden]="isUnassign"
            (ngModelChange)="onTypeChange($event)"
          ></kendo-combobox>
        </div>
      </div>
      <div class="sync-now-container">
        <div class="radio-group">
          <label class="section-label"><strong>Legacy Combos </strong></label>
          <label class="radio-option">
            <input
              type="radio"
              name="hide"
              [checked]="!showLegacyCombo"
              (change)="legacyFilter(false)"
            />
            <strong>Hide</strong>
          </label>
          <label class="radio-option">
            <input
              type="radio"
              name="show"
              [checked]="showLegacyCombo"
              (change)="legacyFilter(true)"
            />
            <strong>Show</strong>
          </label>
        </div>
      </div>
      <div class="action-buttons" *ngIf="!isEditMode">
        <button
          kendoButton
          size="small"
          fillMode="solid"
          (click)="setEditMode()"
          themeColor="primary"
        >
          Edit
        </button>
      </div>
      <div class="action-buttons" *ngIf="isEditMode">
        <button
          kendoButton
          size="small"
          fillMode="solid"
          (click)="onCancelClick()"
          themeColor="error"
        >
          Cancel
        </button>
        <kendo-badge-container>
          <button
            kendoButton
            size="small"
            fillMode="outline"
            [disabled]="cache.size == 0"
            (click)="onSaveItem()"
            themeColor="primary"
          >
            Save
          </button>
          <kendo-badge
            *ngIf="cache.size > 0"
            size="small"
            rounded="full"
            [align]="{ vertical: 'top', horizontal: 'end' }"
            themeColor="success"
            >{{ cache.size }}</kendo-badge
          >
        </kendo-badge-container>
      </div>
      <app-grid-manager-toolbar
        [showConfig]="false"
        [fontSize]="fontSize"
        [showExport]="[]"
        [showImport]="[]"
        (fontSizeChange)="fontSize = $event; setDefaultState()"
        [columns]="columns"
        view="pricing"
      ></app-grid-manager-toolbar>
    </div>
  </div>
</div>

<div class="tab-content-container">
  <div class="tab-box k-card k-card-type-rich">
    <app-data-grid
      [mode]="isEditMode ? 'edit' : 'view'"
      [fontSize]="fontSize"
      [dataItems]="items"
      [columns]="columns"
      [state]="state"
      (dataStateChange)="onDataStateChanged($event)"
      [filterable]="'menu'"
      (valueChange)="cacheChanges()"
    >
      <ng-template
        columnTemplate
        field="parItemId"
        let-row="row"
        let-column="column"
      >
        {{ row.parItemId }}
        <button
          *ngIf="row.hasDirty()"
          kendoButton
          [title]="'This item has unsaved changes'"
          class="m-l-4 warning-bg badge-button"
          size="small"
          rounded="full"
        >
          Unsaved
        </button>
      </ng-template>
      <ng-template
        columnTemplate
        let-row="row"
        let-column="column"
        field="categoryId"
      >
        <ng-container *ngIf="isEditMode; else viewMode">
          <kendo-combobox
            [ngClass]="{ dirty: row.dirty.get(column.field) }"
            [data]="categories"
            textField="name"
            valueField="id"
            [(ngModel)]="row.categoryId"
            placeholder="Select Category"
            [filterable]="true"
            [valuePrimitive]="true"
            [popupSettings]="dropdownPopupSettings"
            (filterChange)="handleFilter($event)"
            (valueChange)="onValueChange(row, column.field)"
          ></kendo-combobox>
        </ng-container>

        <ng-template #viewMode>
          {{ row.categoryName }}
        </ng-template>
      </ng-template>
      <ng-template
        columnTemplate
        let-row="row"
        let-column="column"
        field="productType"
      >
        <ng-container *ngIf="isEditMode; else viewMode">
          <kendo-combobox
            [data]="productTypes"
            textField="name"
            valueField="id"
            [(ngModel)]="row.productType"
            placeholder="Select ProductType"
            [valuePrimitive]="true"
            [popupSettings]="dropdownPopupSettings"
            [disabled]="!row.disableParUpdates"
            (valueChange)="onValueChange(row, column.field)"
          ></kendo-combobox>
        </ng-container>
        <ng-template #viewMode>
          {{ row.productTypeDescription }}
        </ng-template>
      </ng-template>
      <ng-template
        columnTemplate
        field="itemName"
        let-row="row"
        let-column="column"
      >
        <ng-container *ngIf="isEditMode; else viewMode">
          <textarea
            class="item-description-text"
            [ngClass]="{
              dirty: row.dirty.get(column.field),
              disabled: !row.disableParUpdates,
            }"
            kendoTextArea
            [(ngModel)]="row.itemName"
            [disabled]="!row.disableParUpdates"
            (valueChange)="onValueChange(row, column.field)"
          ></textarea>
        </ng-container>

        <ng-template #viewMode>
          {{ row[column.field] }}
        </ng-template>
      </ng-template>
      <ng-template
        columnTemplate
        field="itemDescription"
        let-row="row"
        let-column="column"
      >
        <ng-container *ngIf="isEditMode; else viewMode">
          <textarea
            class="item-description-text"
            [ngClass]="{
              dirty: row.dirty.get(column.field),
              disabled: !row.disableParUpdates,
            }"
            kendoTextArea
            [(ngModel)]="row.itemDescription"
            [disabled]="!row.disableParUpdates"
            (valueChange)="onValueChange(row, column.field)"
          ></textarea>
        </ng-container>

        <ng-template #viewMode>
          {{ row[column.field] }}
        </ng-template>
      </ng-template>

      <ng-template columnTemplate field="plu" let-row="row" let-column="column">
        <ng-container *ngIf="isEditMode; else viewMode">
          <input
            kendoTextBox
            [ngClass]="{
              dirty: row.dirty.get(column.field),
              disabled: !row.disableParUpdates,
            }"
            [(ngModel)]="row.plu"
            [disabled]="!row.disableParUpdates"
            (valueChange)="onValueChange(row, column.field)"
          />
        </ng-container>

        <ng-template #viewMode>
          {{ row[column.field] }}
        </ng-template>
      </ng-template>

      <ng-template
        columnTemplate
        field="bkpn"
        let-row="row"
        let-column="column"
      >
        <ng-container *ngIf="isEditMode; else viewMode">
          <kendo-numerictextbox
            [ngClass]="{
              dirty: row.dirty.get(column.field),
              disabled: !row.disableParUpdates,
            }"
            [(ngModel)]="row.bkpn"
            [disabled]="!row.disableParUpdates"
            [format]="'n0'"
            (valueChange)="onValueChange(row, column.field)"
          ></kendo-numerictextbox>
        </ng-container>

        <ng-template #viewMode>
          {{ row[column.field] }}
        </ng-template>
      </ng-template>

      <ng-template
        columnTemplate
        field="revenueCenterId"
        let-row="row"
        let-column="column"
      >
        <ng-container *ngIf="isEditMode; else viewMode">
          <kendo-combobox
            [ngClass]="{ dirty: row.dirty.get(column.field) }"
            [data]="revenueCenters"
            textField="name"
            valueField="id"
            [(ngModel)]="row.revenueCenterId"
            placeholder="Select Revenue Center"
            [filterable]="true"
            [valuePrimitive]="true"
            [popupSettings]="dropdownPopupSettings"
            [disabled]="!row.disableParUpdates"
            (valueChange)="onValueChange(row, column.field)"
          ></kendo-combobox>
        </ng-container>

        <ng-template #viewMode>
          {{ row.revenueCenterDescription }}
        </ng-template>
      </ng-template>

      <ng-template
        columnTemplate
        field="dependencies"
        let-row="row"
        let-column="column"
      >
        <ng-container *ngIf="isEditMode; else viewMode">
          <kendo-multiselect
            [data]="machineTypes"
            [(ngModel)]="row.dependencies"
            (valueChange)="onValueChange(row, column.field)"
            textField="name"
            valueField="id"
            [placeholder]="'Select Machine Dependencies'"
          ></kendo-multiselect>
        </ng-container>

        <ng-template #viewMode>
          {{ row.dependencies | listToString }}
        </ng-template>
      </ng-template>

      <ng-template
        columnTemplate
        field="documentPath"
        let-row="row"
        let-column="column"
      >
        <div class="k-d-flex k-gap-md k-align-items-start">
          <button
            kendoButton
            themeColor="primary"
            (click)="itemToUploadDocuments = row"
          >
            <fa-icon [icon]="['fas', 'upload']"></fa-icon>
          </button>
          <kendo-panelbar *ngIf="row.documentPath?.length" class="width-100">
            <kendo-panelbar-item title="Attachments">
              <ng-template kendoPanelBarContent>
                <ul
                  class="padding-inline-start-10"
                  *ngFor="let documentPath of row.documentPath"
                >
                  <li class="k-d-flex k-gap-md k-align-items-start">
                    <button
                      kendoButton
                      size="small"
                      themeColor="error"
                      (click)="
                        itemToRemoveDocument = {
                          itemId: row.id,
                          documentPath: documentPath,
                        }
                      "
                    >
                      <fa-icon [icon]="['fas', 'trash']"></fa-icon>
                    </button>
                    <button
                      kendoButton
                      size="small"
                      themeColor="primary"
                      (click)="downloadDocument(row, documentPath)"
                    >
                      <fa-icon
                        *ngIf="documentPath"
                        [icon]="['fas', 'download']"
                      ></fa-icon>
                    </button>
                    <p class="m-0">{{ documentPath }}</p>
                  </li>
                </ul>
              </ng-template>
            </kendo-panelbar-item>
          </kendo-panelbar>
        </div>
      </ng-template>
    </app-data-grid>
  </div>
</div>

<kendo-dialog
  [width]="700"
  *ngIf="showItemUpdatePopup"
  (close)="closeUpdatePopup()"
>
  <kendo-dialog-titlebar>
    <fa-icon
      class="error-icon"
      [icon]="['fas', 'exclamation-circle']"
    ></fa-icon>
    Update Item Details
  </kendo-dialog-titlebar>

  <p>
    <strong>Are you sure you want to update the item details?</strong>
  </p>

  <div
    *ngIf="hasOverrideChanges"
    style="
      background: #fff3e0;
      padding: 16px;
      border-radius: 4px;
      margin-top: 16px;
      border-left: 4px solid #ff9800;
    "
  >
    <div
      style="display: flex; align-items: center; gap: 8px; margin-bottom: 12px"
    >
      <fa-icon
        [icon]="['fas', 'exclamation-triangle']"
        style="color: #ff9800"
      ></fa-icon>
      <strong style="font-size: 14px"
        >Override Protection Change Detected</strong
      >
    </div>

    <p style="margin-bottom: 12px; font-size: 13px">
      You are changing the override protection setting. This affects:
    </p>

    <ul
      style="
        margin-left: 20px;
        margin-bottom: 12px;
        font-size: 13px;
        line-height: 1.8;
      "
    >
      <li>Item Name</li>
      <li>Item Description</li>
      <li>PLU</li>
      <li>BKPN</li>
      <li>A La Carte / Combo flags</li>
      <li>Revenue Center</li>
    </ul>

    <p style="font-size: 13px; color: #666; margin: 0">
      <fa-icon [icon]="['fas', 'info-circle']"></fa-icon>
      When protection is OFF, PAR imports will overwrite custom values.
    </p>
  </div>

  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="closeUpdatePopup()">No</button>
    <button
      kendoButton
      (click)="confirmItemDetailsUpdate()"
      themeColor="primary"
    >
      Yes
    </button>
  </kendo-dialog-actions>
</kendo-dialog>

<kendo-dialog
  *ngIf="itemToUploadDocuments"
  (close)="itemToUploadDocuments = null"
  title="Upload Item Attachments"
>
  <app-importer
    [multiple]="true"
    [importUrl]="importUrl + '/' + itemToUploadDocuments.id"
    (success)="onUploadComplete($event)"
  ></app-importer>
</kendo-dialog>

<kendo-dialog
  *ngIf="itemToRemoveDocument"
  (close)="itemToRemoveDocument = null"
  title="Remove Document"
>
  <p>Are you sure you want to remove the document?</p>
  <p>{{ itemToRemoveDocument.documentPath }}</p>
  <kendo-dialog-actions layout="end">
    <button kendoButton (click)="itemToRemoveDocument = null">Cancel</button>
    <button kendoButton (click)="confirmDocumentRemoval()" themeColor="error">
      Remove
    </button>
  </kendo-dialog-actions>
</kendo-dialog>
